module.exports = __webpack_public_path__ + "img/big-orange2.19c86b95.svg";